<div class="modal-header">
  <h4 class="modal-title w-100 text-center">{{ title }}</h4>
</div>
<div class="modal-body">
  <p class="text-center">{{ message }}</p>
</div>
<div class="modal-footer">
  <button type="button">
    {{ confirmText }}
  </button>
  <button type="button">
    {{ cancelText }}
  </button>
</div>
